import {createBrowserRouter, Navigate} from 'react-router-dom';
import {AppShell} from './layouts/AppShell';
import {ProviderHomeRedirect, ProviderLayout} from './layouts/ProviderLayout';
import {ProtectedRoute} from '@/components/ProtectedRoute';
import {TransactionsPage} from '@/features/transactions/TransactionsPage';
import {TransmissionsPage} from '@/features/transmissions/TransmissionsPage';
import {DEFAULT_PROVIDER, providerHomePath} from '@/config/providers';

// Provider lives in the URL rather than in a store so a link carries the full
// context it was captured in — a shared transaction URL opens against the same
// provider it was copied from.
const defaultHome = providerHomePath(DEFAULT_PROVIDER);

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      {index: true, element: <Navigate to={defaultHome} replace />},
      {
        path: ':providerId',
        element: <ProviderLayout />,
        children: [
          {index: true, element: <ProviderHomeRedirect />},
          {path: 'transactions', element: <TransactionsPage />},
          {path: 'transactions/:id', element: <TransactionsPage />},
          {path: 'transmissions', element: <TransmissionsPage />},
          // `schedules` was this section's name while it was still a stub.
          // Keep the old path resolving so saved links don't bounce a schedule
          // provider all the way back to the default provider's home.
          {
            path: 'schedules',
            element: <Navigate to="../transmissions" replace />,
          },
        ],
      },
      {path: '*', element: <Navigate to={defaultHome} replace />},
    ],
  },
  {
    // Cognito redirects here after login; main.tsx handles token exchange then redirects to /
    path: '/callback',
    element: (
      <div className="flex items-center justify-center h-screen">
        <div className="text-sm text-muted-foreground">Completing sign-in…</div>
      </div>
    ),
  },
]);
